import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'

export const OperacionesTransileView = ({
  silo: { nombreCorto, fechaDeTransile, estado },
  openDialogNuevoTransile,
  openDialogEliminarUltimoTransile,
  cancelar
}) => (
  <Grid container direction='column' justify='space-around' spacing={2} alignItems='center'>
    <Grid item xs={12}>
      <Typography variant='h6'>Operaciones de transile disponibles para <strong>{nombreCorto}</strong></Typography>
    </Grid>
    {(estado === 'U' || estado === 'L') && (
      <Grid item xs={12}>
        <Button
          variant='contained'
          onClick={openDialogNuevoTransile}>
          NUEVO TRANSILE
        </Button>
      </Grid>
    )}
    {fechaDeTransile && (estado === 'U' || estado === 'L') && (
      <Grid item xs={12}>
        <Button
          onClick={openDialogEliminarUltimoTransile}>
          ELIMINAR ULTIMO TRANSILE
        </Button>
      </Grid>
    )}
    <Grid container item spacing={2} justify='flex-end'>
      <Grid item xs='auto'>
        <Button
          color='primary'
          variant='contained'
          startIcon={<HighlightOffIcon />}
          onClick={cancelar}>
          Cerrar
        </Button>
      </Grid>
    </Grid>
  </Grid>
)
